function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext, useMemo } from 'react';
import './InputContainer.css';
import cs from 'classnames';
import getOr from '../../utils/getOr';
import FormLabel from '../FormLabel/FormLabel';
import InlineError from '../InlineError/InlineError';
import InlineDescription from '../InlineDescription/InlineDescription';
import ThemeContext from '../../ThemeContext';
import getLabelId from '../getLabelId';
var getDisplayName = getOr('')('displayName');
var FIELDSETS = ['Fieldset', 'Radiogroup'];
export default function InputContainer(_ref) {
  var metaType = _ref.metaType,
    type = _ref.type,
    _ref$element = _ref.element,
    element = _ref$element === void 0 ? 'span' : _ref$element,
    id = _ref.id,
    _ref$containerId = _ref.containerId,
    containerId = _ref$containerId === void 0 ? undefined : _ref$containerId,
    _ref$containerClassNa = _ref.containerClassName,
    containerClassName = _ref$containerClassNa === void 0 ? '' : _ref$containerClassNa,
    label = _ref.label,
    _ref$labelEscape = _ref.labelEscape,
    labelEscape = _ref$labelEscape === void 0 ? true : _ref$labelEscape,
    labelIcons = _ref.labelIcons,
    description = _ref.description,
    descriptionId = _ref.descriptionId,
    _ref$inputFirst = _ref.inputFirst,
    inputFirst = _ref$inputFirst === void 0 ? false : _ref$inputFirst,
    required = _ref.required,
    requiredId = _ref.requiredId,
    readonly = _ref.readonly,
    size = _ref.size,
    labelHidden = _ref.labelHidden,
    errorId = _ref.errorId,
    errorMsg = _ref.errorMsg,
    children = _ref.children,
    view = _ref.view,
    role = _ref.role,
    attrs = _objectWithoutProperties(_ref, ["metaType", "type", "element", "id", "containerId", "containerClassName", "label", "labelEscape", "labelIcons", "description", "descriptionId", "inputFirst", "required", "requiredId", "readonly", "size", "labelHidden", "errorId", "errorMsg", "children", "view", "role"]);
  var theme = useContext(ThemeContext);
  var Element = element;
  var displayName = getDisplayName(Element);
  var isFieldset = FIELDSETS.includes(displayName);
  var autoId = id && id.length ? id.indexOf('_') === 0 ? id.substring(1) : id : false;
  var _inputFirst = view === 'PRINT' ? false : inputFirst;
  var radiogroupProps = useMemo(function () {
    return displayName === 'Radiogroup' ? {
      required: required,
      readonly: readonly
    } : {};
  }, [displayName, readonly, required]);
  return /*#__PURE__*/React.createElement(Element, Object.assign({
    id: containerId,
    labelledby: isFieldset ? getLabelId(id) : null,
    className: cs("_dm-input-container", "_dm-input-container--".concat(size), "_dm-input-container--".concat(type), "_dm-input-container--".concat(theme), "_dm-input-container--".concat(theme, "--").concat(size), 'auto-input-container', _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, containerClassName, containerClassName), "auto-input-container--".concat(autoId), autoId), "auto-input-container--".concat(metaType), metaType), "auto-input-container--".concat(type), type), "_dm-input-container--".concat((view || '').toLowerCase()), view), "_dm-input-container--".concat(metaType, "--").concat((view || '').toLowerCase()), view))
  }, radiogroupProps), _inputFirst && children, /*#__PURE__*/React.createElement(FormLabel, Object.assign({
    theme: theme,
    metaType: metaType,
    type: type,
    element: isFieldset ? 'span' : 'label',
    htmlFor: id,
    i18n: label,
    escape: labelEscape,
    icons: labelIcons,
    required: required,
    requiredId: requiredId,
    description: description,
    size: size,
    hidden: labelHidden,
    view: view,
    error: !!errorMsg
  }, attrs)), !_inputFirst && children, /*#__PURE__*/React.createElement(InlineError, {
    theme: theme,
    metaType: metaType,
    type: type,
    id: errorId,
    i18n: errorMsg,
    size: size
  }), /*#__PURE__*/React.createElement(InlineDescription, {
    theme: theme,
    description: description,
    id: descriptionId
  }));
}